import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { ENROLLED_OBJECT } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import { useGetDataProperties } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataProperties';
import { getPropertyIcon } from 'automation-ui-formula-editor/data-sources/utils/getPropertyIcon';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import { isLegacyTokenPrefix } from 'automation-ui-formula-editor/data-sources/utils/isLegacyTokenPrefix';
import FormulaEditorTokenTag from 'automation-ui-formula-editor/formula-editor/FormulaEditorTokenTag';
import FormulaSummary from 'automation-ui-formula-editor/formula-editor/FormulaSummary';
import { StringTemplateStartRule } from 'automation-ui-formula-editor/formula-editor/grammar/constants/StartRules';
import { isFieldExpression } from 'automation-ui-formula-editor/formula-editor/grammar/expressionUtils';
// @ts-expect-error autogenerated file
import { parse as hubLParse } from 'automation-ui-formula-editor/formula-editor/grammar/hubL/hubLParser';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FormulaTextLabel = ({
  text
}) => {
  const {
    ranges = [],
    fields = []
  } = useMemo(() => {
    try {
      return hubLParse(text || '', {
        startRule: StringTemplateStartRule
      });
    } catch (_unused) {
      return {};
    }
  }, [text]);
  const tokensToResolveArray = fields.filter(isFieldExpression).map(field => {
    const {
      property,
      prefix
    } = getTokenParts(field.name);
    return isLegacyTokenPrefix(prefix) ? {
      prefix: ENROLLED_OBJECT,
      property
    } : {
      prefix,
      property
    };
  });
  const {
    data,
    loading,
    error
  } = useGetDataProperties(tokensToResolveArray);
  if (ranges) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: ranges.map((range, key) => {
        if (range.type === 'FORMULA') {
          return range.formula ? /*#__PURE__*/_jsx(FormulaSummary, {
            formulaText: range.formula,
            shouldDisplayLiterals: true
          }, key) : /*#__PURE__*/_jsx(FormulaSummary, {
            hubLFormulaText: range.hubl,
            shouldDisplayLiterals: true
          }, key);
        }
        if (range.type === 'FIELD') {
          var _data$get;
          const {
            property,
            prefix
          } = getTokenParts(range.name);
          if (loading) {
            return /*#__PURE__*/_jsx(SkeletonText, {
              width: 80
            }, key);
          }
          const prefixToEval = isLegacyTokenPrefix(prefix) ? ENROLLED_OBJECT : prefix;
          const dataProperty = data === null || data === void 0 || (_data$get = data.get(prefixToEval)) === null || _data$get === void 0 ? void 0 : _data$get.dataSourceProperties[property];
          const label = dataProperty ? dataProperty.label : range.name;
          if (error || !dataProperty) {
            return /*#__PURE__*/_jsx(FormulaEditorTokenTag, {
              label: range.name,
              propertyIconName: getPropertyIcon({
                dataProperty
              }),
              useError: true,
              verticalAlign: "baseline"
            }, key);
          }
          return /*#__PURE__*/_jsx(FormulaEditorTokenTag, {
            label: label,
            propertyIconName: getPropertyIcon({
              dataProperty
            }),
            useError: !dataProperty,
            verticalAlign: "baseline"
          }, key);
        } else {
          // Range is narrowed to type "TEXT"
          return /*#__PURE__*/_jsx("span", {
            children: range.value
          }, key);
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: text
  });
};
export default FormulaTextLabel;